import React from 'react';
import { Typography } from 'antd';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import SenderAvatar from '../../components/Chat/SenderAvatar';
import DOMPurify from 'dompurify'; // 💡 VAPT FIX: Import sanitizer

interface DetailedMessageProps {
  isBotMessage: boolean;
  message: any;
}

const DetailedMessage: React.FC<DetailedMessageProps> = ({
  isBotMessage,
  message,
}) => {
  // 💡 VAPT FIX: Sanitize all dynamic properties object keys before rendering
  const sanitizedQuestion = DOMPurify.sanitize(message?.question || '');
  const sanitizedMessage = DOMPurify.sanitize(message?.message || '');

  return (
    <>
      <div className={`chat-message message-bot`}>
        <SenderAvatar isBot={false} />
        <div className="query-response">
          <b>Detailed:</b> {sanitizedQuestion}
        </div>
      </div>
      <div
        className={`chat-message ${
          isBotMessage ? 'message-bot bot' : 'message-bot'
        }`}
      >
        <SenderAvatar isBot={isBotMessage} />
        <div className="query-response">
          <Markdown className="markdown-content" rehypePlugins={[rehypeRaw]}>
            {sanitizedMessage}
          </Markdown>
        </div>
      </div>
    </>
  );
};

export default DetailedMessage;